import { Alert, Button } from 'antd';
import { DetailPageSkeleton } from '../../../../../shared/components/DetailPageSkeleton';
import type { RateLineImportState } from '../hooks/use-rate-line-import';
import { RateLineImportCommittedPanel } from './RateLineImportCommittedPanel';
import { RateLineImportDropzone } from './RateLineImportDropzone';
import { RateLineImportMissingHeaders } from './RateLineImportMissingHeaders';
import { RateLineImportPreviewPanel } from './RateLineImportPreviewPanel';

interface RateLineImportBodyProps {
  state: RateLineImportState;
  reason: string;
  onReasonChange: (reason: string) => void;
  onChoose: (file: File) => void;
  onCommit: () => void;
  onReset: () => void;
  onGoToProposals: () => void;
}

/** Everything below the page header, switched on the one state the import walks through: pick a file, preview it, commit it, or start over. */
export function RateLineImportBody({ state, reason, onReasonChange, onChoose, onCommit, onReset, onGoToProposals }: RateLineImportBodyProps) {
  if (state.status === 'idle') return <RateLineImportDropzone onChoose={onChoose} />;
  if (state.status === 'previewing') return <DetailPageSkeleton label="Reading the file" fields={2} />;

  if (state.status === 'preview-error') {
    return (
      <>
        <Alert className="mb-4" type="error" showIcon title="Could not read this file" description={state.message} />
        <Button onClick={onReset}>Try another file</Button>
      </>
    );
  }

  if (state.status === 'previewed' || state.status === 'committing' || state.status === 'commit-error') {
    if (!state.result.ok) return <RateLineImportMissingHeaders missingHeaders={state.result.missingHeaders} onReset={onReset} />;
    return (
      <RateLineImportPreviewPanel
        rows={state.result.rows}
        reason={reason}
        onReasonChange={onReasonChange}
        onCommit={onCommit}
        onCancel={onReset}
        committing={state.status === 'committing'}
        commitError={state.status === 'commit-error' ? state.message : undefined}
      />
    );
  }

  if (!state.result.ok) return <RateLineImportMissingHeaders missingHeaders={state.result.missingHeaders} onReset={onReset} />;
  return <RateLineImportCommittedPanel rows={state.result.rows} onGoToProposals={onGoToProposals} onImportAnother={onReset} />;
}
